// extracted by mini-css-extract-plugin
export default {"lettersFilterWrapper":"LettersFilter_lettersFilterWrapper__2OxQV","filterEl":"LettersFilter_filterEl__9KB56","selectedEl":"LettersFilter_selectedEl__kD69K"};